import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { NbToastrService, NbDialogService, NbDialogRef } from '@nebular/theme';
import {
  Assessment,
  AssessmentData,
} from '../../../../@core/interfaces/common/CalorieFriend/assessment';
import { Utility } from '../../../../@core/utils/utility';
import { AssessmentDescriptiveValues } from './DescriptiveValues';
import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import { AssessmentSettingService } from 'app/@core/backend/common/services/CalorieFriend/assessment-settings.service';
import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { th } from 'date-fns/locale';
import { defaultFormValues } from 'app/@core/utils/defaultFormValues';
import { FormlyFormOptions } from '@ngx-formly/core';

export enum AssessmentProgressImageType {
  ProgressImage = '',
  ProgressImageLeft = 'Left',
  ProgressImageRight = 'Right',
}

/**
 * Component for the current user to edit assessment data
 */
@Component({
  selector: 'app-edit-assessment',
  templateUrl: './edit-assessment.component.html',
  styleUrls: ['./edit-assessment.component.scss'],
})
export class EditAssessmentComponent
  extends BaseComponentCanDeactivate
  implements OnInit {
  AssessmentForm: FormGroup = new FormGroup({});
  model: any = {}
  UserId: number = null;
  formlyForm: any;
  patientId: number;

  AddAssessmentLabel = 'Input Assessment Data';
  UpdateAssessmentLabel = 'Update Assessment';
  AssessmentLabel = '';
  ImageLabel = 'Image';
  SelectImageLabel = 'Select';
  assessmentProgressImageType: typeof AssessmentProgressImageType = AssessmentProgressImageType;

  SaveAssessmentLabel = 'Save Assessment';

  MealPlanComplianceLabel = 'Meal Plan Compliance';
  EnergyLevelLabel = 'Energy Level';
  StressLevelLabel = 'Stress Level';
  SleepQualityLabel = 'Sleep Quality';

  WeightLabel = 'Weight';
  BodyFatLabel = 'Body Fat %';
  CommentLabel = 'Comment';
  StartDateLabel = 'Start Date';
  EndDateLabel = 'End Date';

  PreferredUnitLabel = 'Preferred Unit';

  BackLabel = 'Back';
  Created = 'Created';
  Updated = 'Updated';
  ProblemCeatingAssessment = 'A problem occurred submitting the assessment.';

  PatientGuid: string = null;
  AssessmentGuid: string = null;
  PatientName: string = '';
  StartDate: any;
  EndDate: any;
  public isImperialUnit: boolean = false;
  options: FormlyFormOptions = {
    formState: {
      customData: {
        isImperial: true,
        // Add more custom data as needed
      }
    }
  };


  protected readonly unsubscribe$ = new Subject<void>();

  imgHover: boolean = false;
  imgFoodItem: any = null;
  isLoading: boolean = false;
  isImageProgressUpload: boolean = true;

  /** Assessment ctor */
  constructor(
    private fb: FormBuilder,
    private assessmentsService: AssessmentData,
    private dialogRef: NbDialogRef<EditAssessmentComponent>,
    private toasterService: NbToastrService,
    private assessmentSettingService: AssessmentSettingService,
    private PlanViewPatientsService: PatientData,
    dialogService: NbDialogService,
  ) {
    super(dialogService);
  }

  DescriptiveValues = AssessmentDescriptiveValues;

  /**
   * Initializes the component.
   * It creates the Assessment Form and loads the assessment data into it.
   */
  ngOnInit(): void {
    this.InitAssessmentForm();

    if (this.AssessmentGuid !== null) {
      this.loadAssessmentData(this.AssessmentGuid);
      this.AssessmentLabel = this.UpdateAssessmentLabel;
    } else {
      this.AssessmentLabel = this.AddAssessmentLabel;
    }
  }

  /**
   * Initializes the Assessment Form.
   */
  InitAssessmentForm() {

    super.initForm(this.AssessmentForm);
  }

  /**
   * Converts the object given as a parameter {value} to the 'Assessment' type
   * @param value Object to convert into 'Assessment' type
   */
  ConvertToAssessment(value: any): Assessment {
    if (!value.ProgressImageUrl || value.ProgressImageUrl === 'null')
      value.ProgressImageUrl = null;

    const assessment: Assessment = value;
    return assessment;
  }

  /**
   * It converts the inputs of the assessment form into the Assessment type
   * and submit the form to save them
   */
  SaveAssessment() {
    this.model = {
      ...this.model,
      ...this.AssessmentForm.value,
    }
    let Assessment: Assessment = {
      id: this.model.id,
      guid: this.model.guid,
      height: this.model.height,
      weight: this.model.weight,
      bodyFat: this.model.bodyFat,
      mealPlanCompliance: this.model.mealPlanCompliance > 0 ? this.model.mealPlanCompliance : 0,
      energyLevel: this.model.energyLevel > 0 ? this.model.energyLevel : 0,
      stressLevel: this.model.stressLevel > 0 ? this.model.stressLevel : 0,
      sleepQuality: this.model.sleepQuality > 0 ? this.model.sleepQuality : 0,
      progressImageUrl: this.model.progressImageUrl,
      progressImageLeftUrl: this.model.progressImageLeftUrl,
      progressImageRightUrl: this.model.progressImageRightUrl,
      comment: this.model.comment ?? '',
      patientName: this.PatientName,
      patientID: this.patientId,
      submittedByPatient: false,
      startDate: this.StartDate,
      endDate: this.EndDate,
      startDateString: '',
      endDateString: '',
      answersJson: null,
    };

    if(this.model.fileProgressImage) {
      Assessment.fileProgressImage = this.model.fileProgressImage;
      delete this.model.fileProgressImage;
    }
    if(this.model.fileProgressImageRight) {
      Assessment.fileProgressImageRight = this.model.fileProgressImageRight;
      delete this.model.fileProgressImageRight;
    }
    if(this.model.fileProgressImageLeft) {
      Assessment.fileProgressImageLeft = this.model.fileProgressImageLeft;
      delete this.model.fileProgressImageLeft;
    }

// Add the answersJson field after the Assessment object has been constructed
Assessment.answersJson = JSON.stringify(this.model);
    // Assessment = this.ConvertToAssessment(
    //   this.model,
    // );

    Assessment.guid = this.AssessmentGuid;
    Assessment.submittedByPatient = true;
    console.log(Assessment, this.model, this.AssessmentForm.value);
    const observable = this.assessmentsService.update(Assessment);

    super.resetDirty();
    this.isLoading = true;
    observable.pipe(takeUntil(this.unsubscribe$),
    finalize(() => this.isLoading = false)).subscribe(
      () => {
        // todo - refresh biometric history table
        // todo - test submit by patient
        this.handleSuccessResponse();
        this.model.fileProgressImage = Assessment.fileProgressImage;
        this.model.fileProgressImageLeft = Assessment.fileProgressImageLeft;
        this.model.fileProgressImageRight = Assessment.fileProgressImageRight;
      },
      (err) => {
        this.handleWrongResponse();
      },
    );
  }

  /**
   * Method to close the parent dialog container
   */
  Back() {
      this.dialogRef.close();
  }

  /**
   * Handler of Success event of submit
   */
  handleSuccessResponse() {
    if (this.AssessmentGuid === null)
      this.toasterService.success('', `Item ${this.Created}!`);
    else this.toasterService.success('', `Item ${this.Updated}!`);

    this.Back();
  }

  /**
   * Handler of Fail event of submit
   */
  handleWrongResponse() {
    this.toasterService.danger('', this.ProblemCeatingAssessment);
  }

  /**
   * Loads the data of the Assessment given by {guid}
   * @param guid The identifier of the Assessment
   */
  loadAssessmentData(guid) {
    if (guid) {
      const loadAssessment = this.PatientGuid
        ? this.assessmentsService.getByNotification(guid, this.PatientGuid)
        : this.assessmentsService.get(guid);
      loadAssessment
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((assessment) => {
          this.PatientName = assessment.patientName;
          this.patientId = assessment.patientID;
          this.StartDate = assessment.startDateString;
          this.EndDate = assessment.endDateString;
          this.PlanViewPatientsService.get(assessment.patientID, null)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((patient) => {
              this.options.formState.customData.isImperial = patient.isPreferredUnitImperial;
            });

          this.model = {
            id: assessment.id,
            guid: assessment.guid,
            height: assessment.height,
            weight: assessment.weight,
            bodyFat: assessment.bodyFat,
            patientId: this.patientId,
            MealPlanCompliance:
              assessment.mealPlanCompliance > 0
                ? assessment.mealPlanCompliance
                : null,
            energyLevel:
              assessment.energyLevel > 0 ? assessment.energyLevel : null,
            stressLevel:
              assessment.stressLevel > 0 ? assessment.stressLevel : null,
            sleepQuality:
              assessment.sleepQuality > 0 ? assessment.sleepQuality : null,
            comment: assessment.comment ?? '',
            ...JSON.parse(assessment.answersJson??'{}'),
            progressImageUrl: assessment.progressImageUrl,
            progressImageLeftUrl: assessment.progressImageLeftUrl,
            progressImageRightUrl: assessment.progressImageRightUrl,
          };

          this.imgFoodItem = assessment.progressImageUrl;
          if (!this.imgFoodItem || this.imgFoodItem === '') {
            this.imgFoodItem = null;
          }
          if(this.UserId) {
            this.assessmentSettingService.getAssessmentSettingsByUserId(this.UserId)
            .pipe(finalize(()=> {
              this.isLoading = false;
            })).subscribe((data) => {
              if(data) {
                this.formlyForm = JSON.parse(data.customQuestion);
                this.isImageProgressUpload = data.uploadProgressImages;
              } else {
                this.formlyForm = defaultFormValues;
              }
            });
          } else {
            this.PlanViewPatientsService.get(null, this.PatientGuid)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((patient) => {
              this.options.formState.customData.isImperial = patient.isPreferredUnitImperial;
              console.log('Imperial', patient.isPreferredUnitImperial);
              this.assessmentSettingService.getAssessmentSettingsByUserId(patient.createdByUserId)
              .pipe(finalize(()=> {
                this.isLoading = false;
              })).subscribe((data) => {
                console.log(data);
                if(data) {
                this.formlyForm = JSON.parse(data.customQuestion);
                this.isImageProgressUpload = data.uploadProgressImages;
                } else {
                  this.formlyForm = defaultFormValues;
                }
              });
            });
          }
          super.resetDirty();
        });
    }
  }

  /**
   * Event handler for uploading the image
   * @param event Event object
   */
  OnInputImageFileChanged(event, type: AssessmentProgressImageType) {
    if (event) {
      this.model['fileProgressImage' + type] = event;
      this.model['progressImage' + type + 'Url'] = null;
    }
  }

  onResetFoodImage(type: AssessmentProgressImageType) {
    console.log(type);
    this.model['fileProgressImage' + type] = null;
    this.model['progressImage' + type + 'Url'] = null;
  }

  /**
   * Validator that validates the number with the ##.# pattern
   */
  validateNumber = Utility.validateNumber;
}
